import { Box, Grid } from '@mui/material'

function JumboStat({ name, value }) {
    return (
        <Grid item xs={'auto'}>
            <Box sx={{ fontSize: '18px', fontWeight: 500, marginBottom: '20px' }}>{name}</Box>
            <Box sx={{ fontSize: '24px', fontWeight: 700 }}>{value}</Box>
        </Grid>
    )
}

JumboStat.propTypes = {
}

export default JumboStat
